import * as user from './user';
import * as messages from './messages';

export default {
  ...user,
  ...messages
};



// WEBPACK FOOTER //
// ./src/api/index.js